"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _getPrototypeOf;

var _setPrototypeOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/set-prototype-of"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-prototype-of"));

function _getPrototypeOf(o) {
  exports.default = _getPrototypeOf = _setPrototypeOf.default ? _getPrototypeOf2.default : function _getPrototypeOf(o) {
    return o.__proto__ || (0, _getPrototypeOf2.default)(o);
  };
  return _getPrototypeOf(o);
}